import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFaqByIdFn, patchFaqFn, postFaqFn } from 'Services/FAQ';
import CustomInput from 'Shared/CustomInput';
import RichTextEditor from 'Shared/RichTextEditory';

const AddUpdateFAQ = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: getBlogCategoryByIdResponse } = useQuery({
        queryKey: ['get-faq-by-id', id, status],
        queryFn: () => getFaqByIdFn(id),
        enabled: !!id && status === "update"
    })
    const data = getBlogCategoryByIdResponse?.data?.data;

    const { mutate: post } = useMutation(postFaqFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/faq')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const { mutate: patch } = useMutation(patchFaqFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/faq')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const initialValues = {
        question: data?.question || "",
        answer: data?.answer || "",
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.question) return toast.error("Question is required.")
            if (!values.answer) return toast.error("Answer is required.")

            const formData = new FormData();
            formData.append('question', values.question);
            formData.append('answer', values.answer);

            if (status === 'add') {
                post(formData);
            } else {
                formData.append("faq_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div>
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-4 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl !text-black font font-bold text-center">
                    {status === "update" ? "Update" : "Add"} FAQ
                </p>
                <CustomInput formik={formik} label={"Question"} name={"question"} />
                <RichTextEditor formik={formik} label={"Answer"} name={"answer"} />
                <Button
                    type='submit'
                    variant='contained'
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    )
}

export default AddUpdateFAQ;